import React from 'react';
import AdjustChartWidget from './AdjustChartWidget';


export default class ReportPresenterChartTitleSection extends React.Component{
  constructor(props){
    super(props);
    this.state={
      chartWidgetOpen: false,
    }
  };

  render(){
    return(
      <div className="row">
        {this.renderChartTitle()}
        <AdjustChartWidget {...this.props} />
      </div>
    );
  };

  renderChartTitle(){
    return(
      <div className="col-sm-10">
        {
          this.props.columnId 
          ?
          <h6>{this.props.report_details.name}</h6>
          :
          null
        }
      </div>
    );
  };

};